export const preloadImages = (imageUrls: string[]) => {
    return new Promise<void>((resolve) => {
      let loadedCount = 0;
      const total = imageUrls.length;
  
      imageUrls.forEach((src) => {
        const img = new Image();
        img.src = src;
  
        img.onload = () => {
          loadedCount++;
         
          
          if (loadedCount === total) resolve();
        };
  
        img.onerror = () => {
          console.error("Failed to preload image:", src);
          loadedCount++;
          if (loadedCount === total) resolve();
        };
      });
  
      // Resolve immediately if there are no images to preload
      if (total === 0) resolve();
    });
  };
  